<template>
  <el-dialog
    class="adaptationModal"
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="workerGroup.pkId ? '编辑' : '新建'"
    width="1000px"
    top="2vh"
    @close="$reset('form')"
  >
    <el-form ref="form" v-loading="contentLoading" :model="workerGroup" :rules="ruleValidate" class="form" label-width="80px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="workerGroup.pkId" :span="12">
          <el-form-item label="班组编号">
            <el-input v-model="workerGroup.groupNo" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班组名称" prop="groupName">
            <el-input v-model="workerGroup.groupName" placeholder="请输入班组名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班组分类" prop="groupType">
            <el-select v-model="workerGroup.groupType" clearable placeholder="请选择班组分类">
              <el-option v-for="(item, index) in groupTypeList" :key="index" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班组长" prop="groupLeaderName">
            <el-input v-model="workerGroup.groupLeaderName" readonly placeholder="请选择班组长">
              <el-button slot="append" @click="$refs.selectLeader.open()" icon="el-icon-search"></el-button>
            </el-input>
            <employee-select ref="selectLeader" @select="onSelectLeader" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="note">
            <el-input autosize v-model="workerGroup.note" type="textarea" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">班组成员</div>
      <el-button type="primary" style="margin-bottom: 8px" @click="$refs.selectMember.open()"> 添加 </el-button>
      <Table border :columns="groupMembersColumns" :data="workerGroup.groupMembers">
        <template slot="action" slot-scope="{ index }">
          <el-button type="danger" @click="deleteGroupMember(index)">删除</el-button>
        </template>
      </Table>
      <div class="editTitle" style="margin-top: 8px">生产中心</div>
      <el-button type="primary" style="margin-bottom: 8px" @click="$refs.selectWorkCenter.open()"> 添加 </el-button>
      <Table border :columns="groupWorkCentersColumns" :data="workerGroup.groupWorkCenters">
        <template slot="action" slot-scope="{ index }">
          <el-button type="danger" @click="deleteGroupWorkCenter(index)">删除</el-button>
        </template>
      </Table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <employee-select ref="selectMember" @select="onSelectMember" />
    <work-center-select ref="selectWorkCenter" @select="onSelectWorkCenter" />
  </el-dialog>
</template>

<script>
import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
import workCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
export default {
  name: "WorkerGroupEdit",
  components: { EmployeeSelect, workCenterSelect },
  props: {
    groupTypeList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      contentLoading: false,
      submitLoading: false,
      workerGroup: {
        pkId: 0,
        groupType: "",
        groupName: "",
        groupLeaderId: "",
        groupLeaderName: "",
        note: "",
        groupMembers: [],
        groupWorkCenters: [],
      },
      ruleValidate: {
        groupName: { required: true, message: "请输入班组名称", trigger: "blur" },
        groupType: { required: true, message: "请选择班组分类", trigger: "change" },
        groupLeaderName: { required: true, message: "请选择班组长", trigger: "change" },
      },
      groupMembersColumns: [
        {
          title: "员工编号",
          key: "employeeNO",
          width: 100,
          align: "center",
        },
        {
          title: "员工姓名",
          key: "employeeName",
          width: 100,
          align: "center",
        },
        {
          title: "性别",
          key: "gender",
          width: 70,
          align: "center",
          render: (h, params) => {
            return h("div", [h("strong", params.row.gender ? "女" : "男")]);
          },
        },
        {
          title: "所属部门",
          key: "departmentName",
        },
        {
          title: "职位",
          key: "postName",
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
      groupWorkCentersColumns: [
        {
          title: "中心编号",
          key: "workCenterNo",
          width: 100,
          align: "center",
        },
        {
          title: "中心名称",
          key: "workCenterName",
          minWidth: 150,
          tooltip: true,
        },
        {
          title: "生产类型",
          key: "productionTypeName",
          width: 90,
          align: "center",
        },
        {
          title: "载具绑定",
          key: "bindVehicleTypeName",
          width: 90,
          align: "center",
        },
        {
          title: "上料验证",
          key: "isLoadMaterial",
          width: 90,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.isLoadMaterial ? "需要" : "不需要");
          },
        },
        {
          title: "所属车间",
          key: "workshopName",
          minWidth: 150,
          tooltip: true,
        },
        {
          title: "边线库",
          key: "locationName",
          width: 150,
          tooltip: true,
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      if (row) {
        this.getData(row.pkId);
      }
    },

    // 获取班组详细信息
    getData(pkId) {
      this.contentLoading = true;
      this.$http
        .get("basic", `workerGroups/${pkId}`)
        .then((resp) => {
          if (resp.success) {
            console.log(resp.data);
            this.workerGroup = Object.assign(this.workerGroup, resp.data);
            this.workerGroup.groupMembers = resp.data.groupMembersDetail;
            this.workerGroup.groupWorkCenters = resp.data.groupWorkCentersDetail;
            this.contentLoading = false;
          }
        })
        .catch(() => {
          this.contentLoading = false;
        });
    },

    // 选择班组长
    onSelectLeader(row) {
      this.workerGroup.groupLeaderId = row.employeeID;
      this.workerGroup.groupLeaderName = row.employeeName;
    },

    // 选择班组成员
    onSelectMember(row) {
      const arr = this.workerGroup.groupMembers.filter((item) => item.employeeID === row.employeeID);
      if (arr.length) {
        this.$confirm("该员工已存在,请勿重复添加", "错误", {
          type: "error",
          showCancelButton: false,
        });
      } else {
        this.workerGroup.groupMembers.push(row);
      }
    },

    // 删除班组成员
    deleteGroupMember(index) {
      this.workerGroup.groupMembers.splice(index, 1);
    },

    //选择班组生产中心
    onSelectWorkCenter(row) {
      const arr = this.workerGroup.groupWorkCenters.filter((item) => item.pkId === row.pkId);
      if (arr.length) {
        this.$confirm("该生产中心已存在,请勿重复添加", "错误", {
          type: "error",
          showCancelButton: false,
        });
      } else {
        this.workerGroup.groupWorkCenters.push(row);
      }
    },

    // 删除生产中心
    deleteGroupWorkCenter(index) {
      this.workerGroup.groupWorkCenters.splice(index, 1);
    },

    // 编辑、新建
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.workerGroup.groupMembers.length) {
            this.$confirm("请选择班组成员", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          if (!this.workerGroup.groupWorkCenters.length) {
            this.$confirm("请选择生产中心", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          this.submitLoading = true;
          this.workerGroup.groupMembers.forEach((item, i) => {
            item.memberId = item.employeeID;
            item.rowIndex = i + 1;
          });
          this.workerGroup.groupWorkCenters.forEach((item) => {
            item.workCenterId = item.pkId;
          });
          this.$http
            .save("basic", "workerGroups", this.workerGroup)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                if (this.workerGroup.pkId) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 8px;
  padding-bottom: 5px;
}
</style>
